import React from 'react';
import styled from '@emotion/styled';
import { COLORS, Image } from '@podiumhq/design-system';
import { useTracking } from '@podiumhq/tracking';

const EmailClient = ({ name, redirectUrl, imageUrl, trackingEvent }) => {
  const { trackEvent } = useTracking();
  const handleOnClick = () => {
    if (trackingEvent) trackEvent(trackingEvent);
    return window.open(redirectUrl);
  };

  return (
    <Container onClick={handleOnClick}>
      <Image
        sx={{ height: '48px', width: '48px', marginLeft: '12px' }}
        src={imageUrl}
      />
      <Name>{name}</Name>
    </Container>
  );
};

export default EmailClient;

const Name = styled.div`
  font-family: Graphik;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: left;
  padding-left: 12px;
`;

const Container = styled.div`
  width: 100%;
  border: 1px solid ${COLORS.grey.lightest};
  height: 72px;
  max-width: 464px;
  border-radius: 8px;
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  &:hover,
  &:focus {
    outline: none;
    background: ${COLORS.silver.lighter};
  }
`;
